<template>
  <div style="width: 100%; height: 100%;overflow: hidden;">
    <iframe
      src="http://221.213.62.81:801/ChengGongWeb/index.html"
      frameborder="0"
      width="100%" height="100%"
      allowfullscreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
      scrolling="no"
    ></iframe>
    <div class="btn-box" @click="goToPage">地图模式</div>
  </div>
</template>

<script>
export default {
  name: "three-dimensional",
  data() {
    return {};
  },
  computed: {},
  methods: {
    goToPage() {
        this.$router.replace({name: 'indexPage'});
    }
  },
};
</script>

<style lang="scss" scoped>
.btn-box {
    position: absolute;
    left: 180px;
    top: 5px;
    width: 125px;
    height: 35px;
    line-height: 35px;
    padding-left: 56px;
    background-image: url("../../assets/images/cockpit/map-btn.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: inline-block;
    vertical-align: middle;
    color: #fff;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/three-dimensional/three-dimensional.vue